import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/** Matches the title baked into index.html. */
const DEFAULT_TITLE = 'Recall: Read & Remember'

// Declare before <Routes>: sibling effects run in order, and the page's useSeo must run after this reset.
export default function DocumentTitleReset() {
  const { pathname } = useLocation()
  useEffect(() => {
    document.title = DEFAULT_TITLE
  }, [pathname])
  return null
}
